import { useMemo } from 'react'
import { DatabaseZap } from 'lucide-react'
import type { AdminColumn } from '@/components/DataTable/types'
import { GeoRegistryTable } from './GeoRegistryTable'
import { GEO_STR as S, type GeoConfigRow } from './geoApi'

/**
 * A11.17 — Ma'lumot rezidentligi. Har yurisdiksiya uchun saqlash regioni +
 * siyosati (davlat → bitta qoida). JONLI CRUD (upsert): `/admin/geo/residency`.
 */
export function DataResidencyScreen() {
  const columns = useMemo<AdminColumn<GeoConfigRow>[]>(
    () => [
      { key: 'country_code', header: S.code, type: 'id', width: 90 },
      { key: 'storage_region', header: S.storageRegion, type: 'text', minWidth: 160 },
      { key: 'policy', header: S.policyCol, type: 'text', minWidth: 200 },
    ],
    [],
  )

  return (
    <GeoRegistryTable
      screenId="A11.17"
      title={S.residencyTitle}
      description={S.residencyNote}
      addLabel={S.addResidency}
      path="/admin/geo/residency"
      listKey="rules"
      searchKeys={['country_code', 'storage_region', 'policy']}
      fields={[
        { name: 'country_code', placeholder: S.code },
        { name: 'storage_region', placeholder: S.storageRegion },
        { name: 'policy', placeholder: S.policyCol },
      ]}
      columns={columns}
      icon={<DatabaseZap size={28} strokeWidth={1.5} />}
    />
  )
}
